<template>
  <div class="article-lists">
    <ul>
      <li v-for="(art,i) in articles" :key="`art-${i}`">
        <a href="javascript:;" @click="onLink(art.id)">
          <i class="el-icon-notebook-2" />
          <span v-text="art.title" />
        </a>
        <span class="tool" v-if="!disabled">
          <a href="javascript:;" @click="del(i,art.id)">
            <i class="el-icon-delete" />
          </a>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'article-lists',
  props: {
    articles: { required: true, type: Array },
    level: Number,
    index: { type: String, default: '0' },
    delete: Function,
    disabled: { type: Boolean, default: false },
    onClick: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    onLink(id) {
      this.$router.push(`/help/${this.$route.params.type}/document/${id}`)
      this.onClick()
    },
    del(i, id) {
      let num = this.index.split('.')
      num.push(i)
      this.delete(num, this.level, id)
    },
  },
}
</script>

<style lang="less" scoped>
@import './article_lists.less';
</style>
